import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Link as ScrollTo } from 'react-scroll';
import { Element } from 'react-scroll';

const Banner = () => {

  return (
    <Element
      name="datatalent-banner"
      className="data-talent-jobseekers-banner banner-style-1 bg-image height-640 d-flex align-items-center pt-4 pt-md-0"
    >
      <div className="container eduvibe-animated-shape">
      <div>
        <a href="https://m2mtechconnect.com"><img width="90" src="/M2M_Logo_v2.png" alt="logo"></img></a>
      </div>
        <div className="row g-5 align-items-center">
          <div className="order-1 order-xl-1 col-lg-12 col-xl-6 banner-left-content">
            <div className="inner">
              <div className="content position-relative">
                {/* <div className="datatalent-jobseekers-breadcrumb d-flex align-items-center">
                  <Link to="/">Home</Link>
                  <i className="ri-arrow-drop-right-line"></i>
                  TalentBridge
                </div> */}
                <h1 className="datatalent-program-title title mt-4">Accelerate Your <span className="product-banner-title">Career Journey</span></h1>
                <p className="description">
                  TalentBridge combines cutting-edge AI technology with comprehensive career services to help you land your dream job, ace interviews, and build a successful career path.
                </p>
                <div className="read-more-btn banner-btns">
                  <div className="col-6 col-lg-4">
                    <ScrollTo
                      className="edu-btn btn-secondary text-center"
                      to="resume-analysis"
                      spy={true}
                      smooth={true}
                      duration={200}
                    >
                      Start Your Journey<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                    </ScrollTo>
                  </div>
                  <div className="col-6 col-lg-4">
                    <Link className="edu-btn btn-bg-alt text-center" to="/contact-us">Contact Us<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="order-2 order-xl-3 col-lg-12 col-xl-6 d-flex flex-column align-items-center justify-content-center banner-right-content">
            <div className="feature-thumbnail">
              <div className="main-image video-popup-wrapper video-popup-two">
                <img src={`${process.env.PUBLIC_URL}/images/talent-bridge/talent_bridge_banner.jpg`} alt="illustration" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Element>
  )
}

export default Banner;